export default "__VITE_ASSET__BpqOrtsh__"